import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-854467ec"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "Zone"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "title"
}, "注册资本大于", -1));
import BaseRule from "../BaseRule.vue";
import { computed } from "vue";
export default {
  __name: 'RegisteredCapital',
  props: ["index", "data", "item"],
  setup(__props) {
    const props = __props;
    const index = computed(() => props.index);
    const data = computed(() => props.data);
    const item = computed(() => props.item);
    const word = {
      first: "注册资本大于",
      second: "万",
      name: "RegisteredCapital"
    };
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      return _openBlock(), _createBlock(BaseRule, {
        word: word,
        index: _unref(index),
        data: _unref(data)
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_hoisted_2, _createVNode(_component_el_input, {
          class: "input",
          modelValue: _unref(item).value.one,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _unref(item).value.one = $event)
        }, null, 8, ["modelValue"]), _createTextVNode("万并且小于 "), _createVNode(_component_el_input, {
          class: "input",
          modelValue: _unref(item).value.two,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _unref(item).value.two = $event)
        }, null, 8, ["modelValue"]), _createTextVNode("万 ")])]),
        _: 1
      }, 8, ["index", "data"]);
    };
  }
};